module.exports = __webpack_public_path__ + "static/media/Weatherapp.ce577b13.png";